import {useState} from 'react';
import omit from 'lodash/omit';

import CustomInput from '../common/CustomInput';
import CustomSelect from '../common/CustomSelect';
import CustomTextField from '../common/CustomTextField';
import {getLocationEmoji} from '../../helpers/locations';

const InstructionEditor = props => {
  const {value, onChange, instructions = []} = props;
  // const [instructionId, setInstructionId] = useState(null);
  console.log('InstructionEditor.value', value);
  return (
    <CustomInput {...omit(props, 'children')}>
      <CustomSelect
        key={`instruction-select-${value?.instruction_id}`}
        defaultValue={value?.instruction_id}
        options={(instructions || []).map(i => ({
          value: i.id, 
          label: `${getLocationEmoji(i.location_type)} ${i.title}`,
          text: i.text
        }))}
        placeholder="Select pre-written instructions"
        onChange={(e, opt) => {
          // setInstructionId(opt?.value || null);
          const instruction = (instructions || []).find(i => i.id === e?.target?.value);
          const newValue = {
            instruction_id: e?.target?.value || null,
            instructions: instruction?.text || '',
          };
          console.log('InstructionEditor.select.onChange', newValue);
          onChange(
            {...e, target: {...e.target, value: newValue}},
            newValue
          );
        }}
      />
      <CustomTextField
        sx={{marginTop: 1}}
        type='textarea'
        multiline
        rows={2}
        {...omit(props, 'instructions', 'onChange', 'helperText', 'label', 'value')}
        value={value?.instructions || ''}
        onChange={e => {
          // setInstructionId(null);
          const newValue = {
            instruction_id: null,
            instructions: e.target.value,
          };
          console.log('InstructionEditor.onChange', newValue);
          onChange(
            {...e, target: {...e.target, value: newValue}},
            newValue
          );
        }}
      />
    </CustomInput>
  );
};

export default InstructionEditor;